module.exports = __webpack_public_path__ + "static/media/050-glass.c49f0097.svg";